import React from 'react'

const Loader = ({ isButton, ...props }) =>
  !isButton ? (
    <div className={"crtLoader"} {...props}>
      <svg viewBox="0 0 30 20" className="crt-icon-flag-fr">
        <use xlinkHref="#crt-loader"></use>
      </svg>
    </div>
  ) : (
    <div className="crtLoader is-btn" {...props}>
      <svg viewBox="0 0 100 100" className="crt-icon-loader" aria-hidden="true">
        <use xlinkHref="#crt-loader" />
      </svg>
    </div>
  );

export default Loader